import SVG from "react-inlinesvg";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Store/Hooks";
import { selectErrorOrdersData, selectIsPlaceOrderComplete, selectIsPlaceOrderFailed, selectIsPlaceOrderInProgress, selectIsPlaceOrderSuccess, selectSuccessOrdersData } from "../../../Store/Order/selectors";
import { selectUser } from "../../../Store/Provider/selectors";
import SkeletonLoading from "../../../Components/Skeleton/SkeletonLoading";
import { orderActions } from "../../../Store/Order/reducer";
import { useEffect } from "react";
import OrderCompleteTable from "./Tables/OrderCompleteTable";


const OrderComplete = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isPlaceOrderInProgress = useAppSelector(selectIsPlaceOrderInProgress);
  const isPlaceOrderComplete = useAppSelector(selectIsPlaceOrderComplete);
  const isPlaceOrderSuccess = useAppSelector(selectIsPlaceOrderSuccess);
  const isPlaceOrderFailed = useAppSelector(selectIsPlaceOrderFailed);
  const successOrdersData = useAppSelector(selectSuccessOrdersData);
  const errorsOrdersData = useAppSelector(selectErrorOrdersData);
  const userData = useAppSelector(selectUser);
  const date = new Date().toLocaleDateString('en-us', {month:"short", year:"numeric", day:"numeric",hour:"2-digit", minute:"2-digit", timeZoneName:"short"});

  useEffect(() => {
    if (!isPlaceOrderSuccess && !isPlaceOrderFailed && !isPlaceOrderInProgress && !isPlaceOrderComplete) {
      navigate("/addpatientleads");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onDone =() => {
    dispatch(orderActions.resetOrderState());
    navigate("/dashboard");
  }

  return (
    <>
      <div className="main-wrapper">
        <div className="page-inner h-100vh">
          <div className="order-page  ">
            <div className="order-wrapper complete-order-page">
              <div className="order-header-cols">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <div className="mb-3">
                    {isPlaceOrderInProgress ? (
                      <>
                        <SkeletonLoading circle={true} width={80} height={80}/>
                      </>
                    ) : (
                      <>
                        {successOrdersData.length > 0 && errorsOrdersData.length > 0 && (
                          <SVG src="./Assets/Images/Icons/done-warning.svg" />
                        )}
                        {successOrdersData.length > 0 && !errorsOrdersData.length && (
                          <SVG src="./Assets/Images/Icons/done.svg" fill="#66CFC8" />
                        )}
                        {!successOrdersData.length && errorsOrdersData.length > 0 && (
                          <SVG src="./Assets/Images/Icons/error-minus.svg" width={80} height={80} />
                        )}
                      </>
                    )}

                  </div>
                  <h2 className="heading-main mb-3">{isPlaceOrderInProgress ? <SkeletonLoading width={300} height={41} /> : (
                    <>
                      {successOrdersData.length > 0 && errorsOrdersData.length > 0 && (<span className="text-warning">Order Partially Successful</span>)}
                      {successOrdersData.length > 0 && !errorsOrdersData.length && (<span>Order Completed</span>)}
                      {!successOrdersData.length && errorsOrdersData.length > 0 && (<span className="text-error">Order Failed</span>)}
                    </>
                    )}</h2>
                  <p className="pera">
                    {isPlaceOrderInProgress ? (
                      <>
                        <SkeletonLoading width={500} />
                        <SkeletonLoading width={200} />
                      </>
                    ) : (
                      <>
                          {successOrdersData.length > 0 && !errorsOrdersData.length ? ("Thank you for your order") : (
                            "Please check the successful and failed order(s) details below"
                          )}
                      </>
                    )}
                  </p>
                </div>
              </div>
              {/* {!successOrdersData.length && !errorsOrdersData.length && ( */}
                <div className="order-inner">
                  <div className="order-detail-table">
                    <div className="row">
                      <div className="col-sm-6 text-uppercase mb-3">
                        ORDER DATE
                      </div>
                      <div className="col-sm-6 mb-3">
                        { isPlaceOrderInProgress ? (<><SkeletonLoading width={200} height={18} /></>) : date}
                      </div>

                      <div className="col-sm-6 text-uppercase mb-3">
                        SUCCESSFUL ORDER QUANTITY
                      </div>
                      <div className="col-sm-6 mb-3"> 
                        {isPlaceOrderInProgress ? (<><SkeletonLoading width={200} height={18} /></>) : successOrdersData.length ?? 0 +" Qty."}
                      </div>

                      <div className="col-sm-6 text-uppercase mb-3">
                        FAILED ORDER QUANTITY
                      </div>
                      <div className="col-sm-6 mb-3"> 
                        {isPlaceOrderInProgress ? (<><SkeletonLoading width={200} height={18} /></>) : errorsOrdersData.length ?? 0 + " Qty."}
                      </div>

                      <div className="col-sm-6 text-uppercase mb-3">
                        ORDER CUSTOMER
                      </div>
                      <div className="col-sm-6 mb-3">
                        {isPlaceOrderInProgress ? (<><SkeletonLoading width={200} height={18} /></>) : userData.name ?? ""}
                      </div>

                    </div>
                  </div>
                {!isPlaceOrderInProgress && successOrdersData.length > 0 && (
                  <>
                    <div className="container">
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <h5 className="text-success">Successfully placed order(s) for</h5>
                          <OrderCompleteTable
                            customClass="success"
                            loading={isPlaceOrderInProgress}
                            tableData={successOrdersData}
                            isErrorTable={false}
                            dataLength={successOrdersData.length}
                            rowsPerPage={20}
                          />
                        </div>
                      </div>

                    </div>
                  </>
                )}
                {!isPlaceOrderInProgress && errorsOrdersData.length > 0 && (
                  <>
                    <div className="container">
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <h5 className="text-error">Error in placing order(s) for</h5>
                          <OrderCompleteTable
                            customClass="error"
                            loading={isPlaceOrderInProgress}
                            tableData={errorsOrdersData}
                            isErrorTable={true}
                            dataLength={errorsOrdersData.length}
                            rowsPerPage={20}
                          />
                        </div>
                      </div>

                    </div>
                  </>
                )}
                <div className="container mt-4">
                  <div className="text-center">
                    {isPlaceOrderInProgress ? (
                      <>
                        <SkeletonLoading width={300} height={56} />
                      </>
                    ) : (
                      <>
                          <button
                            type="button"
                            onClick={onDone}
                            className="btn btn-success"
                          >
                            Done
                          </button>
                      </>
                    )}
                  </div>
                </div>
                </div>
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderComplete;
